/*
 * Copyright (c) 2026. Tooling Team
 */

export const UNCHANGED_STATUS_VALUE = "UNCHANGED";

export const MAPPING_STATUS_DROPDOWN_OPTIONS = [
  { id: -1, label: "NEEDS_REVIEW", value: "NEEDS_REVIEW" },
  { id: 0, label: "TENTATIVE", value: "TENTATIVE" },
  { id: 1, label: "WONT_MAP", value: "WONT_MAP" },
  { id: 2, label: "MAPPED", value: "MAPPED" },
];

export const getMappingStatusDropdownValues = (mode) => {
  const statusDropdownValues = [...MAPPING_STATUS_DROPDOWN_OPTIONS];

  if (mode === "Bulk Edit" || mode === "Clone") {
    statusDropdownValues.unshift({
      id: -2,
      label: UNCHANGED_STATUS_VALUE,
      value: UNCHANGED_STATUS_VALUE,
    });
  }

  return statusDropdownValues;
};

export const getMappingStatusFilterOptions = () =>
  MAPPING_STATUS_DROPDOWN_OPTIONS.map(({ label, value }) => ({
    label,
    value,
  }));
